import PortalSDK from '@portal/sdk'

// 应用入口菜单对应的Key
export const ENTRY_KEY = ''
// 应用ID
export const APP_ID = 'ubbXUd_wWBk_ydsX3a4GdtPoSoDo5ksbv-5j'

// 构造sdk实例
export const sdk = new PortalSDK({
  appId: APP_ID
})
